import { FormattedMessage } from 'react-intl'

import { LockClosedIcon } from '@gto/icons-react/outline/lock-closed'

import { GateScreen } from '@/components/gate-screen'

export const BetaLockedPage = () => (
  <GateScreen
    badgeLabel={<FormattedMessage id="auth.betaLocked.badge" />}
    color="info"
    description={<FormattedMessage id="auth.betaLocked.description" />}
    icon={LockClosedIcon}
    title={<FormattedMessage id="auth.betaLocked.title" />}
  />
)
